import React, { useState, useEffect, memo } from 'react';
import DynamicIcon from './DynamicIcon';

const DownloadButton = memo(({ darkMode, onClick, className = '', label = '' }) => {
  const [status, setStatus] = useState(null); // null, 'downloading', 'downloaded'

  // REFACTORED: Use useEffect for cleaner side-effect management.
  useEffect(() => {
    let downloadTimer;
    let resetTimer;

    if (status === 'downloading') {
      // Simulate download progress
      downloadTimer = setTimeout(() => {
        setStatus('downloaded');
      }, 1500);
    } else if (status === 'downloaded') {
      // Reset button to initial state after a short delay
      resetTimer = setTimeout(() => {
        setStatus(null);
      }, 1000);
    }
    
    // Cleanup function to cancel timers if the component unmounts
    return () => {
      clearTimeout(downloadTimer);
      clearTimeout(resetTimer);
    };
  }, [status]);
  
  const handleClick = (e) => {
    e.stopPropagation();
    if (status) return; // Prevent multiple clicks while in a state
    
    setStatus('downloading');
    onClick(e);
  };

  return (
    <button
      onClick={handleClick}
      aria-label={status === 'downloading' ? 'Downloading...' : status === 'downloaded' ? 'Downloaded' : 'Download'}
      className={`
        ${className} 
        relative overflow-hidden 
        transform transition-all duration-300
        hover:scale-105 active:scale-95
        ${status === 'downloading' ? `scale-95 cursor-wait bg-gradient-to-r ${darkMode ? 'from-cyan-400 to-blue-400' : 'from-cyan-500 to-blue-500'}` : ''}
        ${status === 'downloaded' ? 'bg-emerald-500' : ''}
      `}
    >
      <span className="relative z-10">
        {status === 'downloading' ? (
          <DynamicIcon name="spinner" darkMode={darkMode} className="h-5 w-5 animate-spin" />
        ) : status === 'downloaded' ? (
          <DynamicIcon name="check" darkMode={darkMode} className="h-5 w-5" />
        ) : (
          <DynamicIcon name="download" darkMode={darkMode} className="h-5 w-5" />
        )}
      </span>
      {label && <span className="relative z-10">{label}</span>}
      
      <span className={`
        absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
        w-0 h-0 rounded-full z-0
        ${darkMode ? 'bg-cyan-400/30' : 'bg-cyan-500/30'}
        transition-all duration-500 ease-out
        ${status === 'downloading' ? 'w-32 h-32 opacity-0' : ''}
      `}></span>
    </button>
  );
});

export default DownloadButton;
